'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { NetworkIcon } from './network-icon';
import { NetworkLogo } from './network-logo';
import { useNetworkProfile } from './use-network-profile';

/**
 * Network logo display
 */
function NetworkSpecificBrand() {
  const $ = _c(5);
  const slug = useParams().slug?.toString() ?? "";
  const networkProfile = useNetworkProfile();
  if (!networkProfile) {
    return null;
  }
  const t0 = `/network/${slug}`;
  let t1;
  if ($[0] !== networkProfile) {
    t1 = <div className="flex items-center gap-2"><NetworkIcon network={networkProfile} /><NetworkLogo network={networkProfile} /></div>;
    $[0] = networkProfile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = <Link href={t0} className="cursor-pointer hover:opacity-80">{t1}</Link>;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
NetworkSpecificBrand.displayName = 'NetworkSpecificBrand';
export { NetworkSpecificBrand };